module.exports = __webpack_public_path__ + "img/thex_background_texture.1ec8464d.svg";